import { Observable } from "rxjs";
import { getCurrentUser } from '../Auth';
import { ProcessType } from "../types";
import { createClient } from "graphql-ws";

(window as any).GRAPHQL_META = {
    port: 4000,
    host: 'graphql.pr4-dev.eu-west-1.aws.private-pmideep.biz',
    path: 'subscription',
    protocol: 'wss',
    connectionParams: {}
}


// let host = 'graphql.pr4-dev.eu-west-1.aws.private-pmideep.biz'
// let port = (window as any).GRAPHQL_META;
// let path = 'subscription'

const client = createClient({
    url: () => {
        const {protocol, host, port, path} = (window as any).GRAPHQL_META;
        return protocol + "://" + host + ":" + port + "/" + path
    },
    connectionParams: () => {
        const { credentials } = getCurrentUser();
        const { accessToken } = credentials

        if (!accessToken) {
            return {};
        }

        const params = {
            Authorization: `Bearer ${accessToken}`,
            ...(window as any).GRAPHQL_META.connectionParams
        };
        console.debug('connectionParams', params)
        return params;
    },
})

const buildQuery = (factory: string, process: string) => {
    return `
    subscription {
        processingObjectPublished(topic: "${factory}/${process}") {
          topic
          entries {
            key 
            value
          }
        }
      }
`
}



// export const setQraphQLStream = (observer: Subscriber<any>, processType: ProcessType | string) => {
//     const unsubscribe = client.subscribe(
// {
//     query: buildQuery('RS7Z', processType),
// },
//         {
//             next: (value) => observer.next(value),
//             error: ({ error }) => {
//                 if (error === DISCONNECT_MGS) {
//                     federatedSignIn();
//                 }
//             },
//             complete: () => observer.complete()
//         },
//     );
//     return () => {
//         unsubscribe()
//     }

// };
export interface GraphQlRareData {
    data: GraphQlData;
  }
export interface GraphQlData {
    processingObjectPublished: ProcessingObjectPublished;
  }
  export interface ProcessingObjectPublished {
    topic: string;
    entries: (EntriesEntity)[];
  }
  export interface EntriesEntity {
    key: string;
    value: string;
  }
  

export const setQraphQLStream = (processType: ProcessType | string): Observable<string[][]> => {
    const { factory } = getCurrentUser();
    console.log(processType, 'GraphQL stream start!')
    return new Observable((observer) =>
        client.subscribe<GraphQlData>(
            {
                query: buildQuery(factory, processType),
            },
            {
                next: (response) => {
                    const entries = response.data.processingObjectPublished.entries.map(({key, value}) => {
                        return [key, value]
                    })

                    observer.next(entries)
                },
                error: (err) => {
                    console.log(processType, 'error: ', err)
                    observer.error(err)
                },
                complete: () => {
                    console.log(processType, 'GRapgQL stream complete!')
                    observer.complete()
                },
            }),
    );
}